import { createSelector } from '@ngrx/store';
import { RootState } from '../../root-store/root.state';
import { SeSideComponentType } from '../se-side-components/se-side-components-models';
import { ISeSideNavFeatureComponentState } from './se-side-nav.state';

export const selectSeSideComponentFeatureState = (state: RootState) => state.seSideNav;

const SideNavIndexing: Record<SeSideComponentType, number> = {
    [SeSideComponentType.reportHistory]: 0,
    [SeSideComponentType.reporting]: 1,
    [SeSideComponentType.patientHistory]: 2,
    [SeSideComponentType.keyImagesPreview]: 3,
    [SeSideComponentType.reportPreview]: 4,
    [SeSideComponentType.details]: 5,
};

export const selectComponentsState = createSelector(
    selectSeSideComponentFeatureState,
    (state) => state.components
);

export const selectActiveSeSideComponentState = createSelector(
    selectComponentsState,
    (components) => {
        const sortedTabs = Object.entries(components)
            .filter(([_, component]) => component.active)
            .sort(([a], [b]) => SideNavIndexing[a as SeSideComponentType] - SideNavIndexing[b as SeSideComponentType]);

        return sortedTabs.map(([type, component]) => ({ ...component, type }));
    }
);

export const selectHasPatientHistory = createSelector(
    selectActiveSeSideComponentState,
    (components: any[] | ISeSideNavFeatureComponentState[]) => Array.isArray(components) &&
        components.some(c => c.type === SeSideComponentType.reportHistory)
);

export const selectLastClickedTab = createSelector(
    selectSeSideComponentFeatureState,
    (state) => state.lastClickedTab ?? null
);

